import {
  IconButton,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import React, { ReactElement, ReactNode } from "react";

import IconAddHeader from "../../../assets/images/icons/icon_add_header.svg";
import IconConfig from "../../../assets/images/icons/icon_config.svg";
import IconRemoveHeader from "../../../assets/images/icons/icon_remove_header.svg";
import { CustomType, DataGridColDef } from "../../../utils/types/listItems";
import ArrowPopover from "../../ArrowPopover/ArrowPopover";
import ImgIcon from "../../ImgIcon/ImgIcon";
import { OptionsBox, StyledList } from "./HeaderSelectionPopover.styles";

type Props = {
  id: string;
  headerFields?: Array<DataGridColDef>;
  handleUpdateHeader: Function;
  icon?: string;
};

const HeaderSelectionPopover: React.FC<Props> = ({
  id,
  headerFields,
  handleUpdateHeader,
  icon = IconConfig,
}: Props): ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleOnClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleOnClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <div>
      <OptionsBox>
        <IconButton
          aria-label="Column Settings"
          color="inherit"
          id={`btn_data_grid_columns_filter_${id}`}
          onClick={handleOnClick}
        >
          <ImgIcon icon={icon} useCursorPointer />
        </IconButton>
      </OptionsBox>
      <ArrowPopover
        id={id}
        anchorEl={anchorEl}
        showPopover={Boolean(anchorEl)}
        handleOnPopoverClose={handleOnClose}
        verticalOrigin="top"
        content={
          <StyledList dense={true}>
            {headerFields?.reduce((prevValue: ReactNode[], currentValue) => {
              if (currentValue?.customType !== CustomType.Action) {
                prevValue.push(
                  <ListItem
                    id={`checkbox-list-label-${currentValue.field}`}
                    key={currentValue.field}
                    secondaryAction={
                      <IconButton
                        id={`${id}_${currentValue.field}`}
                        edge="end"
                        aria-label="delete"
                        onClick={() =>
                          handleUpdateHeader(
                            currentValue.field,
                            currentValue?.inlineFilterName
                          )
                        }
                      >
                        <img
                          id={`${id}_${currentValue.field}_img`}
                          src={
                            currentValue.hide ? IconAddHeader : IconRemoveHeader
                          }
                          alt={`${currentValue.hide ? "Add" : "Remove"} header`}
                        />
                      </IconButton>
                    }
                  >
                    <Typography variant="subtitle1">
                      {currentValue.headerName}
                    </Typography>
                  </ListItem>
                );
              }
              return prevValue;
            }, [] as ReactNode[])}
          </StyledList>
        }
      />
    </div>
  );
};

export default HeaderSelectionPopover;
